import { Award, FlaskConical, UserCheck, CalendarCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SIGNALS = [
  { icon: Award, title: "Lider Merkez", desc: "Kocaeli'nin ilk ve lider Meguiar's araç bakım merkezi." },
  { icon: FlaskConical, title: "Orijinal Ürünler", desc: "Yalnızca orijinal Meguiar's ve profesyonel bakım ürünleri." },
  { icon: UserCheck, title: "Uzman Uygulama", desc: "Her araç, deneyimli ellerde özenle değerlendirilir." },
  { icon: CalendarCheck, title: "Randevulu Hizmet", desc: "Aracınıza acele etmeden, hak ettiği özen gösterilir." },
];

export default function TrustSignals() {
  return (
    <section data-testid="trust-signals" className="border-b border-white/10 bg-black py-16 sm:py-20">
      <div className="container-x grid grid-cols-1 gap-px overflow-hidden border border-white/10 bg-white/[0.06] sm:grid-cols-2 lg:grid-cols-4">
        {SIGNALS.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.title} delay={i * 0.07} className="bg-[#0a0a0a]">
              <div className="group relative h-full p-7 transition-colors duration-300 hover:bg-[#0e0e0e]">
                <span className="absolute right-5 top-5 font-oswald text-sm font-bold tracking-[0.2em] text-white/15 transition-colors group-hover:text-gold/60">
                  0{i + 1}
                </span>
                <span className="flex h-12 w-12 items-center justify-center border border-gold/30 bg-gold/10 text-gold transition-colors group-hover:bg-gold group-hover:text-black">
                  <Icon className="h-6 w-6" />
                </span>
                <h3 className="mt-6 font-display text-lg font-medium text-white">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-neutral-400">{s.desc}</p>
                <span className="absolute inset-x-0 bottom-0 h-px scale-x-0 bg-gold transition-transform duration-500 group-hover:scale-x-100" />
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
